import React from 'react';
import { BOOKING_STATUS_META, bookingReference, bookingDurationMinutes, experienceLabel } from '@/lib/kiosk';
import { ChevronRight } from 'lucide-react';

export default function KioskBookingCard({ booking, selected, experiences, onSelect }) {
  const status = BOOKING_STATUS_META[booking.status] || BOOKING_STATUS_META.confirmed;

  return (
    <button
      id={`kiosk-booking-${booking.id}`}
      onClick={() => onSelect(booking.id)}
      className={`w-full text-left border p-4 transition-colors ${
        selected ? 'border-primary bg-primary/10' : 'border-white/10 bg-[#111115] hover:border-white/25'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-white font-bold text-lg leading-tight truncate">{booking.customer_name}</p>
          <p className="text-white/40 text-[11px] font-mono font-bold tracking-wider mt-1">
            {bookingReference(booking)}
          </p>
        </div>
        <span className={`shrink-0 border px-2.5 py-1 text-[10px] font-bold tracking-widest ${status.badge}`}>
          {status.label}
        </span>
      </div>

      <div className="flex items-center gap-3 mt-4">
        <span className="text-white font-mono font-black text-xl tabular-nums">{booking.time_slot}</span>
        <span className="text-white/20">|</span>
        <span className="text-white/70 text-xs font-bold tracking-wider uppercase truncate">
          {experienceLabel(booking.experience_type, experiences)}
        </span>
      </div>

      <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/10">
        <span className="text-white/40 text-[11px] font-bold tracking-widest">
          {bookingDurationMinutes(booking)} MIN
        </span>
        <span
          className={`flex items-center gap-1.5 text-[11px] font-bold tracking-widest ${
            selected ? 'text-primary' : 'text-white/60'
          }`}
        >
          SELECT FOR DISPATCH <ChevronRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </button>
  );
}